import { check } from '@fingermarkglobal/validation';
import { interpret, getJwtToken } from '@fingermarkglobal/utilities';
import { request } from '@fingermarkglobal/request';
import { preOrderMachine as machine } from './machines/pre-order';
import { buildRequestOptions } from './helpers';

const doPreOrder = ({ payload = null, timeout = 30, transition = null, ip }) => {
  const { instance: preOrderMachine } = interpret({
    name: 'preOrderMachine',
    machine,
    transition,
  });

  // IIFE so we can return the running machine
  (async () => {
    const functionName = 'pre-order';

    const invalidParams = check({
      name: 'Pre-order',
      parameters: { payload },
    });

    preOrderMachine.send('INITIALISE');

    if (invalidParams) {
      preOrderMachine.send('INITIALISE_ERROR', {
        message: `[${functionName}] Fail to validate parameters [${invalidParams}]`,
      });
    }

    const endpoint = process.env.POI_APP_HAWKE_PRE_ORDER_ENDPOINT;
    const localIp = JSON.parse(process.env.POI_APP_HAWKE_ORDER_LOCAL_IP || 'false');

    if (!endpoint)
      preOrderMachine.send('INITIALISE_ERROR', {
        message: `[${functionName}] Failed to get pre order endpoint in the environment file with the key POI_APP_HAWKE_PRE_ORDER_ENDPOINT.`,
      });

    preOrderMachine.send('INITIALISE_SUCCESS');

    try {
      const jwtToken = await getJwtToken();

      if (!jwtToken) {
        preOrderMachine.send('PROCESS_ERROR', {
          message: `[${functionName}] Request made successfully, but an empty response was received`,
        });
      }

      logger.log(`[pre-order] request payload: ${JSON.stringify(payload, null, 2)}`);

      const { endpoint: formattedEndpoint, params } = buildRequestOptions({
        endpoint,
        localIp,
        payload,
        timeout,
        jwtToken,
        ip,
      });

      const response = await request.post(formattedEndpoint, params).json();

      if (!response) {
        preOrderMachine.send('PROCESS_ERROR', {
          message: `[${functionName}] Request failed. Response {${response}}`,
        });
      }

      logger.log(`[pre-order] response payload: ${JSON.stringify(response, null, 2)}`);

      preOrderMachine.send('PROCESS_SUCCESS', { message: response });
      preOrderMachine.send('IDLE');
    } catch (error) {
      const throwError = message =>
        preOrderMachine.send('PROCESS_ERROR', {
          message: `[${functionName}] Failed to handle request [${message}]`,
        });

      if (error?.response) error.response.json().then(data => throwError(data.message));
      // if contains `response` prop it is http error
      else throwError(error);
    }
  })();

  return { preOrderMachine };
};

export { doPreOrder };
